(function ($) {
    'use strict';

    function bool(value) {
        return value === true || value === 1 || value === '1' || value === 'true' || value === 'yes';
    }

    function deviceValue(group, device, fallback) {
        return group && typeof group[device] !== 'undefined' ? group[device] : fallback;
    }

    function currentDevice() {
        if (window.innerWidth >= 1025) { return 'desktop'; }
        if (window.innerWidth >= 768) { return 'tablet'; }
        return 'mobile';
    }

    function syncControls(widget, options) {
        var device = currentDevice();
        var navigationEnabled = bool(deviceValue(options.navigation, device, false));
        var paginationEnabled = bool(deviceValue(options.pagination, device, device !== 'desktop'));

        widget.querySelectorAll('.n3auto-listing-compare__navigation').forEach(function (control) {
            control.hidden = !navigationEnabled;
        });
        var pagination = widget.querySelector('.n3auto-listing-compare__pagination');
        if (pagination) { pagination.hidden = !paginationEnabled; }
    }

    function initializeListingCompare(scope) {
        var root = scope instanceof $ ? scope[0] : scope;
        if (!root) { return; }
        var widgets = root.classList && root.classList.contains('n3auto-listing-compare') ? [root] : root.querySelectorAll('.n3auto-listing-compare');

        Array.prototype.forEach.call(widgets, function (widget) {
            if (!widget.hasAttribute('data-listing-compare-ready')) {
                widget.setAttribute('data-listing-compare-ready', 'true');
                widget.addEventListener('click', function (event) {
                    var link = event.target.closest('.n3auto-listing-compare__button[data-compare-ids]');
                    if (!link || !widget.contains(link)) { return; }

                    var ids = (link.getAttribute('data-compare-ids') || '').split(',').map(function (id) {
                        return parseInt(id, 10);
                    }).filter(Boolean).slice(0, 2);

                    if (ids.length !== 2 || ids[0] === ids[1]) { return; }
                    try {
                        var storageKey = widget.getAttribute('data-storage-key') || 'n3auto_compare_listings';
                        window.localStorage.setItem(storageKey, JSON.stringify(ids.map(String)));
                    } catch (error) {
                        // The query-string IDs remain a safe fallback when storage is unavailable.
                    }
                });
            }

            var swiperElement = widget.querySelector('.n3auto-listing-compare__swiper');
            if (!swiperElement || typeof window.Swiper === 'undefined') { return; }

            var options;
            try { options = JSON.parse(swiperElement.getAttribute('data-options') || '{}'); }
            catch (error) { options = {}; }

            if (swiperElement.swiper) { swiperElement.swiper.destroy(true, true); }

            var previous = widget.querySelector('.n3auto-listing-compare__navigation--prev');
            var next = widget.querySelector('.n3auto-listing-compare__navigation--next');
            var pagination = widget.querySelector('.n3auto-listing-compare__pagination');
            var desktopSlides = Number(deviceValue(options.slidesPerView, 'desktop', 3)) || 3;
            var count = Number(swiperElement.getAttribute('data-count')) || 0;
            var config = {
                slidesPerView: Number(deviceValue(options.slidesPerView, 'mobile', 1)) || 1,
                spaceBetween: Number(deviceValue(options.spaceBetween, 'mobile', 16)) || 0,
                speed: Number(options.speed) || 600,
                loop: bool(options.loop) && count > desktopSlides,
                grabCursor: bool(options.grabCursor),
                watchOverflow: true,
                observer: true,
                observeParents: true,
                keyboard: { enabled: bool(options.keyboard), onlyInViewport: true },
                navigation: {
                    prevEl: previous,
                    nextEl: next,
                    enabled: bool(deviceValue(options.navigation, 'mobile', false))
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    enabled: bool(deviceValue(options.pagination, 'mobile', true))
                },
                breakpoints: {
                    0: {
                        slidesPerView: Number(deviceValue(options.slidesPerView, 'mobile', 1)) || 1,
                        spaceBetween: Number(deviceValue(options.spaceBetween, 'mobile', 16)) || 0,
                        navigation: { enabled: bool(deviceValue(options.navigation, 'mobile', false)) },
                        pagination: { enabled: bool(deviceValue(options.pagination, 'mobile', true)) }
                    },
                    768: {
                        slidesPerView: Number(deviceValue(options.slidesPerView, 'tablet', 2)) || 2,
                        spaceBetween: Number(deviceValue(options.spaceBetween, 'tablet', 22)) || 0,
                        navigation: { enabled: bool(deviceValue(options.navigation, 'tablet', false)) },
                        pagination: { enabled: bool(deviceValue(options.pagination, 'tablet', true)) }
                    },
                    1025: {
                        slidesPerView: desktopSlides,
                        spaceBetween: Number(deviceValue(options.spaceBetween, 'desktop', 27)) || 0,
                        navigation: { enabled: bool(deviceValue(options.navigation, 'desktop', false)) },
                        pagination: { enabled: bool(deviceValue(options.pagination, 'desktop', false)) }
                    }
                }
            };

            if (bool(options.autoplay)) {
                config.autoplay = {
                    delay: Number(options.autoplayDelay) || 4000,
                    pauseOnMouseEnter: bool(options.pauseOnHover),
                    disableOnInteraction: false
                };
            }

            var swiper = new window.Swiper(swiperElement, config);
            syncControls(widget, options);
            swiper.on('breakpoint', function () { syncControls(widget, options); });
            swiper.on('resize', function () { syncControls(widget, options); });
        });
    }

    $(function () { initializeListingCompare(document); });
    $(window).on('elementor/frontend/init', function () {
        if (window.elementorFrontend && elementorFrontend.hooks) {
            elementorFrontend.hooks.addAction('frontend/element_ready/n3auto-listing-compare.default', initializeListingCompare);
        }
    });
})(jQuery);